import { useRef, useState, useEffect } from "react";
export default (options, valueName) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
      setSearchTerm(""); // reset search when dropdown closes
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // Filter options based on search term (case-insensitive)
  const filteredOptions = options.filter((option) =>
    option[valueName].toLowerCase().includes(searchTerm.toLowerCase())
  );
  return {
    dropdownRef,
    isOpen,
    toggleDropdown,
    searchTerm,
    setSearchTerm,
    filteredOptions,
    setIsOpen,
  };
};
